import axios from 'axios'
import library from '../../../utils/Library'

export const getUserLoginAccountWithID = async (loginaccountID) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('login_account') + '/loginAccountById'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      loginAccountId: loginaccountID
    }
  })
}
